import { useNotification } from '@kyvg/vue3-notification';
import { UiNotifier } from '@amarkets/atlas/esm/lib/ui-notifier';

export const createUiNotifier = () => {
  const notification = useNotification();

  return new UiNotifier(notification);
};
